import { render, staticRenderFns } from "./honor-card.vue?vue&type=template&id=e7c70078&scoped=true"
import script from "./honor-card.vue?vue&type=script&lang=js"
export * from "./honor-card.vue?vue&type=script&lang=js"
import style0 from "./honor-card.vue?vue&type=style&index=0&id=e7c70078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c70078",
  null
  
)

export default component.exports